var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAuthIllustration = function SvgAuthIllustration(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 516,
    height: 251,
    viewBox: "0 0 516 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 138.564H49.7346V101.568H87.7174V119.392L107.376 138.547H122.059V72.2335H169.121V119.622H199.573V101.666H247.196V28.2653H259.934V0H287.337V28.4955H300.635V138.531L336.08 127.268V90.8632L376.782 114.097V76.7388H400.594V122.729H427.997V89.9095C427.997 71.0003 445.728 55.6591 467.595 55.6591V112.666H515.755V251H0V138.547V138.564Z",
    fill: "#003639"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1391 101.579H49.7351V138.576H58.1391V101.579Z",
    fill: "url(#paint0_linear_1127_52044)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.925 72.2452H122.06V138.559H149.925V72.2452Z",
    fill: "url(#paint1_linear_1127_52044)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M231.145 101.682H199.589V119.637H231.145V101.682Z",
    fill: "url(#paint2_linear_1127_52044)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M259.95 28.2794H247.213V101.68H259.95V28.2794Z",
    fill: "url(#paint3_linear_1127_52044)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M273.414 0.0313721H259.935V28.2966H273.414V0.0313721Z",
    fill: "url(#paint4_linear_1127_52044)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M336.081 90.911H315.45V133.86L336.081 127.315V90.911Z",
    fill: "url(#paint5_linear_1127_52044)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M376.783 76.767H363.485V106.545L376.783 114.142V76.767Z",
    fill: "url(#paint6_linear_1127_52044)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M420.336 122.762H427.999V89.942C427.999 71.0492 445.696 55.7244 467.547 55.6915L467.596 55.6093H434.376C419.611 61.1999 420.353 82.1152 420.353 88.9718V122.745L420.336 122.762Z",
    fill: "url(#paint7_linear_1127_52044)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1127_52044",
    x1: 53.9371,
    y1: 161.546,
    x2: 53.9371,
    y2: 108.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1127_52044",
    x1: 136.001,
    y1: 160.823,
    x2: 136.001,
    y2: 103.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1127_52044",
    x1: 215.359,
    y1: 130.407,
    x2: 215.359,
    y2: 109.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1127_52044",
    x1: 253.573,
    y1: 111.316,
    x2: 253.573,
    y2: 71.5242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1127_52044",
    x1: 266.674,
    y1: 33.9201,
    x2: 266.674,
    y2: 13.2843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1127_52044",
    x1: 325.765,
    y1: 141.456,
    x2: 325.765,
    y2: 106.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1127_52044",
    x1: 370.143,
    y1: 123.53,
    x2: 370.143,
    y2: 88.7374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1127_52044",
    x1: 443.966,
    y1: 127.333,
    x2: 443.966,
    y2: 94.9406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406867"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAuthIllustration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "auth_illustration.40199cd2813c3052d7971e9ef7c379ed.svg";